import { useEffect, useState } from 'react'
import PaymentList from './PaymentList'
import { useRequest } from '../../api/utils'
import { Banner, LoadingWand } from '@ordr-as/umami-react'
import { useSearchParams } from 'react-router-dom'
import Search from '../../components/Search'
import OverviewPageTemplate from 'pages/OverviewPageTemplate'
import { useSearchPayments } from 'api/paymentApi'
import { ClientPaymentDto } from '../../../generated-api'
import PaymentPaginationButtons from './PaymentPaginationButtons'

const toIntOrZero = (maybeInt: string | null) => {
    if (maybeInt === null) return 0
    const parsed = parseInt(maybeInt)
    return isNaN(parsed) ? 0 : parsed
}

const PaymentsOverview = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [payments, setPayments] = useState<ClientPaymentDto[]>()

    const searchPayments = useSearchPayments()
    const searchQuery = searchParams.get('q') || ''
    const pageNumber = toIntOrZero(searchParams.get('page'))

    const { run: runGetPayments, loading, error } = useRequest(() => searchPayments(searchQuery, pageNumber))

    const [searchQueryEffectCompletedInitialRun, setSearchQueryEffectCompletedInitialRun] = useState<boolean>(false)

    useEffect(() => {
        runGetPayments().then((paymentsPage) => {
            setPayments(paymentsPage)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber, searchQuery])

    useEffect(() => {
        if (searchQueryEffectCompletedInitialRun && pageNumber > 0) {
            setPageNumber(0)
            return
        }
        setSearchQueryEffectCompletedInitialRun(true)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery])

    const cancelSearchFilter = () => {
        setPageNumber(0)
        setSearchParams({})
    }

    const setPageNumber = (pageNumber: number) =>
        setSearchParams(searchQuery ? { q: searchQuery, page: pageNumber.toString() } : { page: pageNumber.toString() })

    const setSearchQuery = (newQuery: string) => setSearchParams({ q: newQuery, page: pageNumber.toString() })

    return (
        <OverviewPageTemplate heading="Payments">
            {loading ? (
                <LoadingWand className="mx-auto" />
            ) : error ? (
                <Banner kind="error" onClose={() => null} stretch="parent" className="my-3">
                    {error?.message}
                </Banner>
            ) : (
                <div className="py-2 max-w-screen-widescreen">
                    <Search
                        placeHolder="Search payment reference"
                        initialValue={searchQuery}
                        onSubmit={setSearchQuery}
                        onCancel={cancelSearchFilter}
                    />

                    <PaymentList payments={payments || []} />
                    <PaymentPaginationButtons pageNumber={pageNumber} onSwapPage={setPageNumber} />
                </div>
            )}
        </OverviewPageTemplate>
    )
}

export default PaymentsOverview
